module.exports = __webpack_public_path__ + "img/18-5 (RedteaGO Global eSIM Plan) _en.0428cf19.png";